import { UserNote } from "../UserNote";
import { OnlineFulfillmentInstructions } from "./OnlineFulfillmentInstructions";
import { QrWaiterFulfillmentInstructions } from "./QrWaiterFulfillmentInstructions";
import { FulfillmentMethodTypeStorageManager } from "../../storageManagers/FulfillmentMethodTypeStorageManager";
const PAYMENT_MEDIUM_STORAGE_KEY = "client_paymentMedium";
export function equalPaymentChannelIds(a, b) {
    if (a.tag !== "StripeChannel" && b.tag !== "StripeChannel") {
        return a.tag === b.tag && a.contents === b.contents;
    }
    return a.tag === "StripeChannel" && b.tag === "StripeChannel";
}
export const DEFAULT_FULFILLMENT_TYPE = "DineIn";
export const FulfillmentInstructions = {
    create(params) {
        var _a, _b;
        const paymentMedium = this.restorePaymentMedium(params.restaurant.paymentMethods, params.restaurant.paymentChannels);
        const paymentMediumRestored = paymentMedium !== null;
        const fulfillmentMethodTypeStorageManager = new FulfillmentMethodTypeStorageManager((_b = (_a = params.restaurant.fulfillmentMethods) === null || _a === void 0 ? void 0 : _a.raw) !== null && _b !== void 0 ? _b : []);
        const fulfillmentMethodType = fulfillmentMethodTypeStorageManager.restore();
        if (params.dineInLocationNumber === null) {
            return new OnlineFulfillmentInstructions({
                fulfillmentMethodType,
                fulfillmentTime: params.fulfillmentTime,
                deliveryAddress: params.deliveryAddress,
                userNote: UserNote.empty(),
                paymentMedium,
                paymentMediumRestored,
            });
        }
        else {
            return new QrWaiterFulfillmentInstructions({
                userNote: UserNote.empty(),
                paymentMedium,
                paymentMediumRestored,
                dineInLocationNumber: params.dineInLocationNumber,
            });
        }
    },
    persistPaymentMedium(paymentMedium) {
        const paymentMediumDataString = JSON.stringify(paymentMedium);
        localStorage.setItem(PAYMENT_MEDIUM_STORAGE_KEY, paymentMediumDataString);
    },
    restorePaymentMedium(paymentMethods, paymentChannels) {
        const paymentMediumDataString = localStorage.getItem(PAYMENT_MEDIUM_STORAGE_KEY);
        if (paymentMediumDataString === null) {
            return null;
        }
        const medium = JSON.parse(paymentMediumDataString);
        if (medium.type === "method") {
            const availableMethod = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.findWhere((method) => method === medium.method);
            if (availableMethod !== undefined) {
                return medium;
            }
        }
        if (medium.type === "channel") {
            const availableChannel = paymentChannels === null || paymentChannels === void 0 ? void 0 : paymentChannels.filtered((channel) => channel.enabled === true).findWhere((channel) => equalPaymentChannelIds(channel.id, medium.channelId));
            if (availableChannel !== undefined) {
                return medium;
            }
        }
        return null;
    },
};
